import React, { useState, useEffect } from "react";
import { Input, Button, Form } from "antd";
import { Col, Row } from "antd";

import { SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import history from "../../../routes/history";
import { getImage } from "../../../utilities/storageOperations/downloadURL";
import "./EmpDetails.css";
import { useDispatch, useSelector } from "react-redux";
import { updateEmpAlbums, editEmpAlbums, editEmpAlbumsRESET, updateEmpAlbumsRESET } from "../../../redux/actions";
import Loader from "../../../components/Loading/Loader";
import { LoadingOutlined } from '@ant-design/icons';

const EmpDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const successUpdate = useSelector((state) => state.updateEmpAlbumsReducer.success);
  const successEdit = useSelector((state) => state.editEmpAlbumsReducer.success);

  const [fname, setfname] = useState(location.state.Name);
  const [jobtitle, setjobtitle] = useState(location.state.Title);
  const [jobDescription, setJobDescription] = useState(
    location.state.Description
  );
  const [work, setWork] = useState(location.state.WorkCulture);
  const [imageUrl, setimageUrl] = useState("");
  const [load, setLoad] = useState(false);
  const [form] = Form.useForm();


  useEffect(() => {
    getPicture(location.state.Key);
  }, []);
  useEffect(() => {
    if (successUpdate) {
      dispatch(updateEmpAlbumsRESET())
      // history.push('/companyprofile/addemployee');
      history?.replace('/companyprofile/addemployee');
    }
  }, [successUpdate])

  useEffect(() => {
    if (successEdit) {
      dispatch(editEmpAlbumsRESET())
      history.goBack();
    }
  }, [successEdit])

  const getPicture = (Key) => {

    var url = Key;
    if (url !== null) {
      setimageUrl(`${process.env.REACT_APP_S3_URL}/content/pics/albums/${url}`);
    }
  };

  const SubmitDetails = async () => {
    const values = await form.validateFields();
    if (location.state.type === "Update") {
      dispatch(
        updateEmpAlbums({
          type: "PEOPL",
          Pictures: [
            {
              Filename: location.state.Key,
              FileSize: location.state.FileSize,
              Name: fname,
              Title: jobtitle,
              Description: jobDescription,
              WorkCulture: work,
            },
          ],
        })
      );
    }
    if (location.state.type === "Edit") {
      dispatch(
        editEmpAlbums({
          id: location.state.id,
          type: "PEOPL",
          Picture: {
            Filename: location.state.Key,
            FileSize: location.state.FileSize,
            Name: fname,
            Title: jobtitle,
            Description: jobDescription,
            WorkCulture: work,
          },
        })
      );
    }
    setLoad(true)
  };

  return (
    <div className="empdetails-Detail">
      <Col xl={14} lg={14} md={18} sm={24} xs={24} className="empdetails-resp" >
        <Form form={form} fields={[
          {
            name: ["fName"],
            value: fname,
          },
          {
            name: ["jobTitle"],
            value: jobtitle,
          },
          {
            name: ["jobDescription"],
            value: jobDescription,
          },
          {
            name: ["work"],
            value: work,
          },
        ]}>
          {/* <Input
          className="emp-search-detail"
          size="large"
          type={'input'}
          placeholder="Find candidates"
          prefix={<SearchOutlined className="site-form-item-icon" />}
        /> */}
          <ArrowLeftOutlined
            className="empdetails-back-none"
            onClick={() => history.push('/companyprofile/addemployee')}
          />
          {/* <div className="empdetails-mainheading">Tell us more about your employee</div> */}
          {/* <div className="empdetails-txt">
          Share more about your employee, the impact they’ve made, and their experience working at the company.
          </div> */}

          <div className="empdetails-subcont" >
          <div className="empdetails-mainheading">Tell us more about your employee</div>
            <div style={{ width: "200px", height: "200px" }}>
              <img
                src={imageUrl}
                alt="Picture"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
            {/* ................................................................... */}

            <div className="empdetails-heading">Full name</div>

            <Form.Item
              name="fName"
              // style={{background: 'blue'}} 
              rules={[
                // {
                //   required: true,
                //   message: "Please add your full name",
                // },
                {
                  validator: (_, value) => {
                    if (!value.trim() == "") {
                      if ( /^[A-Za-z\s]*$/.test(value)) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject(
                          new Error("Please enter valid Full Name")
                        );
                      }
                    } else {
                      return Promise.reject(new Error("Please add your full name"));
                    }
                  },
                },
              ]}
            >
              <Input
                type={'input'}
                placeholder="Employee Name"
                className="empdetails-head"
                onChange={(e) => {
                  setfname(e.target.value)
                }
                // onKeyDown={(e) => {
                //   (e.which === 48 || e.which === 49|| e.which === 50|| e.which === 51|| e.which === 52 || e.which === 53 || e.which === 54 || e.which === 55 || e.which === 56 || e.which === 57) && e.preventDefault()
                //   // e.which === 32 && e.preventDefault()
                // }
              }
              />
            </Form.Item>
            <div className="empdetails-heading">
            Job title
            </div>
            <Form.Item
              name="jobTitle"
              // style={{background: 'blue'}}
              rules={[
                {
                  required: true,
                  message: "Please add a job title",
                },
              ]}
            >
              <Input
                type={'input'}
                maxLength={200}
                value={jobtitle}
                placeholder="Manager"
                className="custom-input empdetails-head "
                onChange={(e) => setjobtitle(e.target.value)}
              />
              <div style={{display:'flex',justifyContent:'flex-end',color:'#7E7E7E'}}>200 characters</div>
            </Form.Item>

            <div className="empdetails-heading">
            Job description
            </div>

            <Form.Item
              name="jobDescription"
              // style={{background: 'blue'}}
              rules={[
                {
                  required: true,
                  message: "Please add job description",
                },
              ]}
            >
              <Input              
                maxLength={200}
                type={'input'}
                value={jobDescription}
                placeholder="Working as a manager"
                className="empdetails-head custom-input"
                onChange={(e) => setJobDescription(e.target.value)}
              />
              <div style={{display:'flex',justifyContent:'flex-end',color:'#7E7E7E'}}>200 characters</div>
            </Form.Item>
            <Row>
              <div className="empdetails-heading">
              Favorite part about working
              </div>
            </Row>
            <Form.Item
              name="work"
              // style={{background: 'blue'}}
              rules={[
                {
                  required: true,
                  message: "Favorite part about working here cannot be empty",
                },
              ]}
            >
              <Input                
                maxLength={300}
                type={'input'}
                value={work}
                placeholder="Good culture"
                className="empdetails-head custom-inputs"
                onChange={(e) => setWork(e.target.value)} />
                <div style={{display:'flex',justifyContent:'flex-end',color:'#7E7E7E'}}>300 characters</div>
            </Form.Item>

            {/* ..................................................................... */}

          </div>
         
          <div className="empdetails-Sub" >
          <Button
              className="empdetails-back"
              
              onClick={() => history.push('/companyprofile')} >
             
              <span style={{color:'#3E3E3E'}}>Back to profile</span>
            </Button>
            <Button
              className="empdetails-button"
              // style={{border:'4px solid black', width:'10px'}}
              onClick={() => SubmitDetails()} >
              {
                load ?
                  <LoadingOutlined />
                  : "Next"
              }
            </Button>

          </div>
        </Form>
      </Col>
    </div>
  );
};

export default EmpDetails;
